var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "setting-main-container" }, [
    _c(
      "form",
      {
        attrs: { action: "" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submitSupplierData($event)
          },
        },
      },
      [
        _c("div", { staticClass: "card setting-card" }, [
          _c("div", { staticClass: "page-header" }, [
            _c("h3", { staticClass: "page-title" }, [
              _vm._v(_vm._s(_vm.$t("suppliers.supplier_process"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row  mb-4" }, [
            _c("div", { staticClass: "col-md-6 mb-6" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$tc("suppliers.withholding_tax_rate"))),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "base-input" },
                [
                  _c(
                    "money",
                    _vm._b(
                      {
                        staticClass: "input-field",
                        class: {
                          invalid: _vm.$v.formData.withholding_tax_rate.$error,
                        },
                        model: {
                          value: _vm.formData.withholding_tax_rate,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "withholding_tax_rate", $$v)
                          },
                          expression: "formData.withholding_tax_rate",
                        },
                      },
                      "money",
                      _vm.defaultInput,
                      false
                    )
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-6" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$tc("suppliers.other_tax"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "base-input" },
                [
                  _c(
                    "money",
                    _vm._b(
                      {
                        staticClass: "input-field",
                        class: { invalid: _vm.$v.formData.other_tax.$error },
                        model: {
                          value: _vm.formData.other_tax,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "other_tax", $$v)
                          },
                          expression: "formData.other_tax",
                        },
                      },
                      "money",
                      _vm.defaultInput,
                      false
                    )
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.$v.formData.withholding_tax_rate.$error
                ? _c("div", [
                    !_vm.$v.formData.withholding_tax_rate.between
                      ? _c(
                          "span",
                          { staticClass: "form-group__message text-danger" },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("validation.enter_valid_tax_rate"))
                            ),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-6" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(_vm._s(_vm.$tc("general.supplier_id"))),
                ]),
                _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
                _vm._v(" "),
                _c("base-input", {
                  class: { invalid: _vm.$v.formData.supplier_id.$error },
                  attrs: {
                    label: _vm.$t("general.supplier_id"),
                    type: "text",
                    "tab-index": "2",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.supplier_id.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.supplier_id,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "supplier_id",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.supplier_id",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.supplier_id.$error
                  ? _c("div", [
                      !_vm.$v.formData.supplier_id.required
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [_vm._v(_vm._s(_vm.$t("validation.required")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.supplier_id.alphaNum
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [_vm._v(_vm._s(_vm.$t("validation.alphaNum")))]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-6" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(_vm._s(_vm.$tc("general.payment_term"))),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  class: { invalid: _vm.$v.formData.tenor.$error },
                  attrs: {
                    label: _vm.$t("general.tenor"),
                    type: "numeric",
                    "tab-index": "2",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.tenor.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.tenor,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "tenor",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.tenor",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.tenor.$error
                  ? _c("div", [
                      !_vm.$v.formData.tenor.numeric
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [_vm._v(_vm._s(_vm.$t("validation.numbers_only")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.tenor.minValue
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [
                              _vm._v(
                                "\n              Should be greater than 0\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-6" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(_vm._s(_vm.$tc("general.approval_days"))),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  class: { invalid: _vm.$v.formData.approval_days.$error },
                  attrs: {
                    label: _vm.$t("general.approval_days"),
                    type: "numeric",
                    "tab-index": "2",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.approval_days.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.approval_days,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "approval_days",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.approval_days",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.approval_days.$error
                  ? _c("div", [
                      !_vm.$v.formData.approval_days.numeric
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [_vm._v(_vm._s(_vm.$t("validation.numbers_only")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.approval_days.minValue
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [
                              _vm._v(
                                "\n              Should be greater than 0\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-6" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(_vm._s(_vm.$tc("general.cif_buyer"))),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  class: { invalid: _vm.$v.formData.cif_buyer.$error },
                  attrs: {
                    label: _vm.$t("general.cif_buyer"),
                    type: "text",
                    "tab-index": "2",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.cif_buyer.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.cif_buyer,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "cif_buyer",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.cif_buyer",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.cif_buyer.$error
                  ? _c("div", [
                      !_vm.$v.formData.cif_buyer.required
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [_vm._v(_vm._s(_vm.$t("validation.required")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.cif_buyer.alphaNum
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [_vm._v(_vm._s(_vm.$t("validation.alphaNum")))]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-6" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(_vm._s(_vm.$tc("general.cif_seller"))),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  class: { invalid: _vm.$v.formData.cif_seller.$error },
                  attrs: {
                    label: _vm.$t("general.cif_seller"),
                    type: "text",
                    "tab-index": "2",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.cif_seller.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.cif_seller,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "cif_seller",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.cif_seller",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.cif_seller.$error
                  ? _c("div", [
                      !_vm.$v.formData.cif_seller.required
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [_vm._v(_vm._s(_vm.$t("validation.required")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.cif_seller.alphaNum
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [_vm._v(_vm._s(_vm.$t("validation.alphaNum")))]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 mb-6" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(_vm._s(_vm.$tc("general.program_code"))),
                ]),
                _vm._v(" "),
                _c("base-input", {
                  class: { invalid: _vm.$v.formData.program_code.$error },
                  attrs: {
                    label: _vm.$t("general.program_code"),
                    type: "text",
                    "tab-index": "2",
                  },
                  on: {
                    input: function ($event) {
                      return _vm.$v.formData.program_code.$touch()
                    },
                  },
                  model: {
                    value: _vm.formData.program_code,
                    callback: function ($$v) {
                      _vm.$set(
                        _vm.formData,
                        "program_code",
                        typeof $$v === "string" ? $$v.trim() : $$v
                      )
                    },
                    expression: "formData.program_code",
                  },
                }),
                _vm._v(" "),
                _vm.$v.formData.program_code.$error
                  ? _c("div", [
                      !_vm.$v.formData.program_code.required
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [_vm._v(_vm._s(_vm.$t("validation.required")))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.formData.program_code.alphaNum
                        ? _c(
                            "span",
                            { staticClass: "form-group__message text-danger" },
                            [_vm._v(_vm._s(_vm.$t("validation.alphaNum")))]
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row " }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c(
                  "base-button",
                  {
                    attrs: {
                      loading: _vm.isLoading,
                      disabled: _vm.isLoading,
                      icon: "save",
                      color: "theme",
                      type: "submit",
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$tc("profile.business_status.save")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }